module.exports = __webpack_public_path__ + "img/10.db01b2f8.png";